import axios from 'axios';
import Vue from 'vue'

export default {

    getMails (page, pageSize, start,end,customerId) {
        return axios.get('/api/mails/list', { params: { page: page, pageSize: pageSize, start: start , end:end,customerId:customerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    createMailMessage(formData) {
    return axios.post('/api/mails/create', formData, {
        headers: {
        "Content-Type": "multipart/form-data"
        }
    })
    .then(response => {
        if (response && response.data) return response.data;
    })
    .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteMail (page, pageSize, start,end,customerId, messageId) {
        return axios.get('/api/mails/delete', { params: { page: page, pageSize: pageSize, start: start , end:end,customerId:customerId, id:messageId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    
    downloadAttachment(id) {
        axios.get('/api/mails/download/attachment', {
            params: { id: id },
            responseType: 'blob'
        })
        .then(response => {
            if (response && response.data) {
                let fileName = 'attachment';
                const disposition = response.headers['content-disposition'];

                if (disposition && disposition.indexOf('filename=') !== -1) {
                    const matches = disposition.match(/filename\*?=(?:UTF-8''|")?([^;"']+)/i);
                    if (matches != null && matches[1]) {
                        fileName = decodeURIComponent(matches[1].trim());
                    }
                }

                const blob = new Blob([response.data], { type: response.data.type });
                const fileURL = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = fileURL;
                link.download = fileName;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(fileURL);
            }
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
    }

}

